﻿import common = require("../../common");
import context = require("../context");
import SearchBox = require("../../core/SearchBox");

interface ISettings extends common.ISearchBoxConfig {
    /** Permet d'activer le searchbox (default: false) */
    enableSearchBox?: boolean;
}

class DefaultSearchBox implements common.IWebComponent {
    isEnabledSearchBox: boolean;
    private _isInit = false;
    //private _loader: core.Loader;
    protected _searchBox: SearchBox;
    protected readonly _defaultFiltersFormName = 'DefaultSearchBoxFilters';

    init(s: ISettings) {
        if (this._isInit)
            return;
        this._isInit = true;

        //this._loader = new core.Loader(this._vueElId);
        this.isEnabledSearchBox = s.enableSearchBox === true;

        this.setupSearchBox(s.searchBoxSettings, s.filtersFormName);

        return context.components.add(this);
    }

    destroy() {

        if (this._searchBox){
            this._searchBox.destroy();
            this._searchBox = null;
        }       
    }

    private setupSearchBox(searchBoxSettings: common.ISearchBoxSettings, filtersFormName?: string) {
        if (!this.isEnabledSearchBox) {
            this._searchBox = null;
            return;
        }

        if (!searchBoxSettings)
            throw "L'argument 'searchBoxSettings' est requis";

        filtersFormName = filtersFormName || filtersFormName === null ? filtersFormName : this._defaultFiltersFormName;

        const pooler = context.components.getPooler();
        this._searchBox = new SearchBox(searchBoxSettings, filtersFormName, pooler);
    }

    getSearchBox() {
        return this._searchBox;
    }
}

export = DefaultSearchBox;
